<template>

    <div style="width: 611px;">
        <div class="centent-comment-title-div">
            <div class="centent-comment-title">
                脂肪肌肉评估
            </div>
            <div class="centent-comment-title" style="font-size: 13px;color: #333333;margin-left: 5px;"> Fat and Muscle
                Assessment</div>
        </div>
        <!-- 表格 -->
        <div class="tabel-box" style="margin-top: 4px;">
            <div class="tabel-tr-flex ">
                <div class="tabel-tr-title-one"></div>
                <div class="tabel-tr-title-item mr">偏低</div>
                <div class="tabel-tr-title-item mr">标准</div>
                <div class="tabel-tr-title-item mr">偏高</div>
                <div class="tabel-tr-title-item mr">标准范围</div>
                <div class="tabel-tr-title-item mr">与上次对比</div>
            </div>
            <div class="tabel-tr-flex ">
                <div class="line-white"></div>
                <div class="line-green "></div>
            </div>
            <div class="tabel-tr-flex ">
                <div class="tabel-tr-title-one">&nbsp;&nbsp;体重&nbsp;<span class="unit-span"
                        v-if="isBodyDataNotEmpty()">({{
                            isBodyDataNotEmpty() ? bodyData.bodyComposition[0].unit : "" }})</span></div>
                <div class="tabel-tr-title-item-prograss">
                    <ProgressBar :standardValue="isBodyDataNotEmpty() ? bodyData.bodyComposition[0].value : ''"
                        :progressValue="isBodyDataNotEmpty() ? weightStandardCalculate(bodyData.bodyComposition[0]) : 0"
                        :width="294" :height="7" />
                </div>

                <div class="tabel-tr-title-item-nomal" v-if="isBodyDataNotEmpty()">[{{ isBodyDataNotEmpty() ?
                            bodyData.bodyComposition[0].scope : ""
                    }}]
                </div>
                <div class="tabel-tr-title-item-contrast">
                    <img class="tabel-tr-title-item-contrast-img"
                        :src="isBodyDataNotEmpty() ? swichUpOrDown(bodyData.bodyComposition[0].value, lstBody[2].value) : ''" />
                    {{ isBodyDataNotEmpty() ? Math.abs(bodyData.bodyComposition[0].value - lstBody[2].value).toFixed(1) : '' }}
                </div>
            </div>
            <div class="tabel-tr-flex ">
                <div class="line-white"></div>
                <div class="line-green "></div>
            </div>
            <div class="tabel-tr-flex ">
                <div class="tabel-tr-title-one">&nbsp;&nbsp;骨骼肌&nbsp;<span class="unit-span"
                        v-if="isBodyDataNotEmpty()">({{
                            isBodyDataNotEmpty() ? bodyData.fatMuscle[3].unit : "" }})</span></div>
                <div class="tabel-tr-title-item-prograss">
                    <ProgressBar :standardValue="isBodyDataNotEmpty() ? bodyData.fatMuscle[3].value : ''"
                        :progressValue="isBodyDataNotEmpty() ? weightStandardCalculate(bodyData.fatMuscle[3]) : 0"
                        :width="294" :height="7" />
                </div>

                <div class="tabel-tr-title-item-nomal" v-if="isBodyDataNotEmpty()">[{{ isBodyDataNotEmpty() ?
                            bodyData.fatMuscle[3].scope : '' }}]
                </div>
                <div class="tabel-tr-title-item-contrast">
                    <img class="tabel-tr-title-item-contrast-img"
                        :src="isBodyDataNotEmpty() ? swichUpOrDown(bodyData.fatMuscle[3].value, lstBody[5].value) : ''" />
                    {{ isBodyDataNotEmpty() ? Math.abs(bodyData.fatMuscle[3].value - lstBody[5].value).toFixed(1) : '' }}
                </div>
            </div>
            <div class="tabel-tr-flex ">
                <div class="line-white"></div>
                <div class="line-green "></div>
            </div>
            <div class="tabel-tr-flex ">
                <div class="tabel-tr-title-one">&nbsp;&nbsp;体脂肪&nbsp;<span class="unit-span"
                        v-if="isBodyDataNotEmpty()">({{
                            isBodyDataNotEmpty() ? bodyData.bodyComposition[1].unit : "" }})</span></div>
                <div class="tabel-tr-title-item-prograss">
                    <ProgressBar :standardValue="isBodyDataNotEmpty() ? bodyData.bodyComposition[1].value : ''"
                        :progressValue="isBodyDataNotEmpty() ? weightStandardCalculate(bodyData.bodyComposition[1]) : ''"
                        :width="294" :height="7" />
                </div>

                <div class="tabel-tr-title-item-nomal" v-if="isBodyDataNotEmpty()">[{{ isBodyDataNotEmpty() ?
                            bodyData.bodyComposition[1].scope : ''
                    }}]
                </div>
                <div class="tabel-tr-title-item-contrast">
                    <img class="tabel-tr-title-item-contrast-img"
                        :src="isBodyDataNotEmpty() ? swichUpOrDown(bodyData.bodyComposition[1].value, lstBody[8].value) : ''" />
                    {{ isBodyDataNotEmpty() ? Math.abs(bodyData.bodyComposition[1].value - lstBody[8].value).toFixed(1) : '' }}
                </div>
            </div>
            <div class="tabel-tr-flex ">
                <div class="line-white"></div>
                <div class="line-green "></div>
            </div>
        </div>

    </div>
</template>
<script>
import ProgressBar from '@/components/ProgressBar.vue';
export default {
    data() {
        return {
        }
    },
    props: {
        bodyData: {
            type: Object,
            required: true
        },
        lstBody: {
            type: Array,
            required: true
        }
    },
    components: {
        ProgressBar,
    },
    mounted() {
    },
    methods: {
        //计算比例
        weightStandardCalculate(composition) {
            const lval = Number(composition.lval)
            const rval = Number(composition.rval)
            const value = Number(composition.value)
            // 最小值
            let minNumber = lval - (rval - lval);
            // 最大值
            let maxNumber = rval + (rval - lval);
            // 获取值的百分比
            let averageNumber = (value - minNumber) * 100 / (maxNumber - minNumber);
            if (averageNumber > 100) {
                averageNumber = 100;
            } else if (averageNumber < 10) {
                averageNumber = 10;
            }
            return Math.round(averageNumber);
        },
        //swich上下剪头图片
        swichUpOrDown(thisNumber, lastNumber) {
            //下降
            if ((Number(thisNumber) - Number(lastNumber)) < 0) {
                return require("@/assets/icon-contrast-down.png")
            } else if ((Number(thisNumber) - Number(lastNumber)) == 0) {
            } else {
                return require("@/assets/icon-contrast-up.png")
            }
        },
        isBodyDataNotEmpty() {
            return this.bodyData && Object.keys(this.bodyData).length > 0;
        }
    }
}
</script>

<style scoped>
/* 内容局域  头部文字的公共样式*/
.centent-comment-title-div {
    display: flex;
    flex-direction: row;
}

.centent-comment-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 19px;
    color: #000000;
    line-height: 26px;
    text-align: left;
    font-style: normal;
}

/* 总表格横向列排列 */
.tabel-box {
    display: flex;
    flex-direction: column;
    border: 1px solid #F0F9F6;
}

.tabel-tr-flex {
    display: flex;
    flex-direction: row;
}

/* 白色下划线 */
.line-white {
    height: 1px;
    background: #F0F9F6;
    width: 112px;
}

/* 绿色下划线 */
.line-green {
    background: #F0F9F6;
    height: 1px;
    width: 494px;
}

.tabel-tr-title-one {
    width: 112px;
    height: 34px;
    line-height: 34px;
    text-align: left;
    font-weight: bold;
    font-size: 13px;
    color: #333333;
}

.tabel-tr-title-item {
    width: 96px;
    height: 34px;
    line-height: 34px;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    border-left: 1px solid #F0F9F6;
}

.tabel-tr-title-item-nomal {
    width: 98px;
    height: 34px;
    line-height: 34px;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    border-left: 1px solid #F0F9F6;
}

.tabel-tr-title-item-nomal {
    width: 98px;
    height: 34px;
    line-height: 34px;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
}

.tabel-tr-title-item-prograss {
    width: 294px;
    height: 34px;
    line-height: 34px;
    font-weight: 400;
    font-size: 13px;
    color: #333333;

}

.tabel-tr-title-item-contrast {
    width: 98px;
    height: 34px;
    line-height: 34px;
    font-weight: bold;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    border-left: 1px solid #F0F9F6;
}

.tabel-tr-title-item-contrast-img {
    width: 5px;
    height: 9px;
}

.mr {
    margin-left: 1px;
}

.unit-span {
    font-weight: 500;
    font-size: 11px;
    color: #333333;
    line-height: 16px;
}
</style>